import { render } from "./Atendente.vue?vue&type=template&id=50c87ebf"
import script from "./Atendente.vue?vue&type=script&lang=js"
export * from "./Atendente.vue?vue&type=script&lang=js"

import "./guiche.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__